module.exports = __webpack_public_path__ + "static/img/changjia.ad22502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/changjia.png
// module id = y+c0
// module chunks = 73